(function () {
  var root = document.querySelector('[data-em]');
  if (!root) return;
  var triggers = [].slice.call(root.querySelectorAll('.em-trigger'));
  var items = triggers.map(function (t) { return t.parentNode; });
  var drawer = document.getElementById('em-drawer');
  var scrim = root.querySelector('.em-scrim');
  var title = root.querySelector('[data-em-title]');
  var backBtn = root.querySelector('[data-em-back]');
  var stack = [];
  var timer, lastFocus;

  /* ---------- Desktop panels ---------- */
  function panelOf(t) { return document.getElementById(t.getAttribute('aria-controls')); }
  function closeAll(except) {
    setTimeout(shopSync, 0);
    triggers.forEach(function (t) {
      if (t === except) return;
      t.setAttribute('aria-expanded', 'false');
      var p = panelOf(t); if (p) p.hidden = true;
    });
  }
  var shopBtns = [].slice.call(document.querySelectorAll('[data-elif-shop]'));
  var header = document.querySelector('.elif-header');
  function isDesk() { return matchMedia('(min-width:1024px)').matches; }
  function shopSync() {
    var on = triggers.some(function (t) { return t.getAttribute('aria-expanded') === 'true'; }) || (drawer && !drawer.hidden);
    shopBtns.forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
  }
  function place(p) {
    if (!root.querySelector('.em-top--single') || !header) return;
    var top = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    p.style.top = top + 'px'; p.style.maxHeight = 'calc(100vh - ' + top + 'px)';
  }
  function open(t) { closeAll(t); var p = panelOf(t); place(p); t.setAttribute('aria-expanded', 'true'); p.hidden = false; shopSync(); }
  function toggle(t) { t.getAttribute('aria-expanded') === 'true' ? closeAll() : open(t); }

  triggers.forEach(function (t) {
    t.addEventListener('click', function () { toggle(t); });
    t.parentNode.addEventListener('mouseenter', function () {
      if (!matchMedia('(hover:hover)').matches) return;
      clearTimeout(timer); timer = setTimeout(function () { open(t); }, 120); /* hover intent */
    });
    t.parentNode.addEventListener('mouseleave', function () {
      clearTimeout(timer); timer = setTimeout(closeAll, 180);
    });
    t.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { open(t); var a = panelOf(t).querySelector('a'); if (a) { e.preventDefault(); a.focus(); } }
      var i = triggers.indexOf(t);
      var rtl = document.documentElement.dir === 'rtl';
      if (e.key === (rtl ? 'ArrowLeft' : 'ArrowRight') && triggers[i + 1]) triggers[i + 1].focus();
      if (e.key === (rtl ? 'ArrowRight' : 'ArrowLeft') && triggers[i - 1]) triggers[i - 1].focus();
    });
  });
  items.forEach(function (li) {
    li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) { var t = li.querySelector('.em-trigger'); if (t) { t.setAttribute('aria-expanded', 'false'); panelOf(t).hidden = true; } } });
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-elif-shop]')) return;
    if (!root.querySelector('.em-bar').contains(e.target)) closeAll();
  });
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-elif-shop]'); if (!s) return;
    e.preventDefault();
    if (isDesk() && triggers.length) {
      var t = triggers[0];
      if (t.getAttribute('aria-expanded') === 'true') { closeAll(); }
      else { open(t); var a = panelOf(t).querySelector('a'); if (a && e.detail === 0) a.focus(); }
    } else { openDrawer(s); }
    shopSync();
  });
  window.addEventListener('scroll', function () { triggers.forEach(function (t) { if (t.getAttribute('aria-expanded') === 'true') place(panelOf(t)); }); }, { passive: true });

  /* ---------- Mobile drawer ---------- */
  function show(id, back) {
    [].forEach.call(drawer.querySelectorAll('[data-em-panel]'), function (p) { p.hidden = p.getAttribute('data-em-panel') !== id; });
    var p = drawer.querySelector('[data-em-panel="' + id + '"]');
    title.textContent = p.getAttribute('data-title');
    backBtn.hidden = id === 'root';
    var f = p.querySelector('a,button'); if (f) f.focus();
  }
  function openDrawer(btn) {
    lastFocus = btn || document.activeElement;
    drawer.hidden = false; scrim.hidden = false; stack = ['root'];
    document.body.style.overflow = 'hidden';
    var b = document.querySelector('[data-elif-menu]'); if (b) b.setAttribute('aria-expanded', 'true');
    show('root'); shopSync();
  }
  function closeDrawer() {
    drawer.hidden = true; scrim.hidden = true; document.body.style.overflow = '';
    var b = document.querySelector('[data-elif-menu]'); if (b) b.setAttribute('aria-expanded', 'false');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    shopSync();
  }
  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-elif-menu]'); if (m) { e.preventDefault(); openDrawer(m); return; }
    var d = e.target.closest('[data-em-drill]'); if (d) { stack.push(d.getAttribute('data-em-drill')); show(stack[stack.length - 1]); return; }
    if (e.target.closest('[data-em-back]')) { stack.pop(); show(stack[stack.length - 1] || 'root'); return; }
    if (e.target.closest('[data-em-close]')) closeDrawer();
  });
  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = [].filter.call(drawer.querySelectorAll('a,button'), function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Escape + resize ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openT = triggers.filter(function (t) { return t.getAttribute('aria-expanded') === 'true'; })[0];
    if (openT) { closeAll(); openT.focus(); }
    if (!drawer.hidden) closeDrawer();
  });
  matchMedia('(min-width:1024px)').addEventListener('change', function (m) { if (m.matches && !drawer.hidden) closeDrawer(); });
})();
